export default (value) => {
  return typeof value === 'undefined' || value === null;
};
